import './lib/jquery'

function removeSpinner() {
  $('.loading-spinner-container').css('display', 'none')
}

document.addEventListener('DOMContentLoaded', () => {
  $('object[type="application/pdf"]').on('load', () => {
    removeSpinner()
  })

  $('object[type="application/pdf"]').on('error', () => {
    removeSpinner()
  })
})
